import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateCityComponent = loadable(
  () => import("../../components/City/CreateCity")
);
const CreateCity = () => {
  const { mutateAsync, isPostLoading  } = usePostHook({
    queryKey: ["city"],
    navigateURL: "/city",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create City</span>
      </div>
      <CreateCityComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate}
        />
    </>
  );
};

export default CreateCity;
